import * as React from 'react'

import NewQuestionConfigModal from 'modules/surveys/components/Questions/AddQuestion/NewQuestionConfigModal'
import { useQuestionGroupConfig } from 'modules/surveys/hooks/useQuestionGroupConfig'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import questionConfigs from 'modules/surveys/store/collections/questionConfigs'

interface Props {
  surveyId: number
  onClose: () => void
  questionGroupConfigId: number
  questionCategoryId?: number
}

export default function AddQuestionModalContainer({
  surveyId,
  onClose,
  questionGroupConfigId,
  questionCategoryId,
}: Props) {
  const { questionGroupConfig } = useQuestionGroupConfig(questionGroupConfigId)
  const { updateCanBeStarted } = useSurveyShowContext()

  const createQuestionConfig = async (data: Record<string, any>) => {
    if (!questionGroupConfig) return

    await questionConfigs.create({
      question_group_config_id: questionGroupConfig.attributes.id,
      question_category_id: questionCategoryId,
      surveys_form_id: surveyId,
      custom_field: data,
    })

    await updateCanBeStarted()
  }

  return <NewQuestionConfigModal onClose={onClose} onSubmit={createQuestionConfig} />
}
